import {loop, Effects} from 'redux-loop';

import {SIGNOUT, REGISTER, ME_INIT} from './actions';
import {signoutTask, registerTask} from './tasks';


export default (state = {}, action) => {
  if (action.type === SIGNOUT) {
    return loop(
      state
    ,
      Effects.promise(signoutTask),
    );
  }

  if(action.type === 'UPDATE_ME_SUCCESS') {
    return {
      ...state,
      ...action.data,
    }
  }

  if (action.type === REGISTER) {
    return loop(
      state,
      Effects.promise(registerTask, action.data)
    )
  }

  if (action.type === ME_INIT) {
    const me = JSON.parse(localStorage.me);
    console.log(me)
    return loop({
      ...me,
    },
      Effects.none()
    )
  }

  return loop(state, Effects.none());
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/me/reducer.js
 **/